import React, {Component} from 'react'
import {observer, inject} from 'mobx-react'
import Select from '../Select'
import {debounce} from 'throttle-debounce'

@inject('store') @observer
class Compare extends Component {
  constructor(props) {
    super(props)
    this.debouncedSearch = debounce(500, this.handleSearch)
  }
  componentDidMount() {
    this.props.store.symbols.search('')
  }
  handleSearch = (value) => {
    const {analysis, symbols} = this.props.store
    const type = analysis.has_coins ? 3 : 1
    symbols.search(value, type)
  }
  handleChange = (e) => {
    const value = e.target.getAttribute('value')
    this.props.store.analysis.compareTickers(value)
  }
  render() {
    const {list, loading} = this.props.store.symbols
    const symbols = list.map(item => ({
      value:item.symbol,
      label:item.symbol.replace('CRYPTO-', '') + (item.symbol_name ? ` - ${item.symbol_name}` : '')
    }))
    const {compare} = this.props.store.analysis

    const searchProps = {
      loading,
      onSearch: this.debouncedSearch
    }

    return(
      <Select
        label='Compare'
        searchProps={searchProps}
        onSelect={this.handleChange}
        items={symbols}
        selected={compare.ticker}
        loadingItems={compare.loading ? compare.ticker : null}
      />
    )
  }
}

export default Compare
